module.exports = __webpack_public_path__ + "images/emoji/pig2.c4f1146cf7be4967634c.png";